export const serverManagementTopics: string[] = [
    "Gestión de Servidores",
    "Mantenimiento IT",
    "Soporte Técnico",
    "Infraestructura IT",
    "Administración de Sistemas",
    "Monitoreo de Servidores",
    "Gestión de Redes",
    "ITSM",
    "Soporte Técnico Empresarial",
    "Optimización de Infraestructura",
    "Administración de Hardware",
    "Service Desk",
    "Help Desk",
    "Gestión de Parches",
    "Virtualización de Servidores",
    "Red Team",
    "Seguridad Perimetral",
    "Implementación de Políticas de Seguridad",
    "DevOps",
    "Automatización IT"
  ];
  